<div class="content-body ad-report">
    <p class="header-text d-flex justify-space-between align-items-center">
        <span>Audit Report</span>
        <button
            mat-button
            class="header-text-close d-flex align-items-center"
            disableRipple
            (click)="onCloseClick()"
            >
            <mat-icon>close</mat-icon>
        </button>
    </p>
    <div class="alert-message mb-10" *ngIf="isViewPermission$ | async">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    {{ commonNotificationText.ViewOnlyAccessMessage }}
    </div>
    <div class="p-0" [ngClass]="(isViewPermission$ | async) ? 'is-readonly' : ''">
        <div class="d-flex justify-space-between align-items-center p-2">
            <form [formGroup]="auditDetailForm">
                <div>
                    <div class="d-flex gap-15">
                        <div class="form-field">
                            <p>Auditor's <span class="text-red">*</span></p>
                            <div class="d-flex gap-10">
                                <ng-select
                                    formControlName="name"
                                    class="wp-100"
                                    [disableOptionCentering]="true"
                                    panelClass="mat-select-position"
                                    #audit
                                    (focus)="audit.open()"
                                    (valueChange)="audit.close()"
                                    (change)="onAuditChange($event)"
                                    >
                                    <ng-option *ngFor="let item of auditList" [value]="item.id">{{ item.name }} {{item?.lastName}}</ng-option>
                                </ng-select>
                                <button
                                    class="action-button primary-button add-btn"
                                    type="button"
                                    mat-button
                                    disableRipple
                                    (click)="addAuditDialog()"
                                    >
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="form-field">
                            <p>Firm Name</p>
                            <mat-form-field>
                                <input matInput formControlName="firmName" autocomplete="off" type="text"/>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex gap-15">
                        <div class="form-field">
                            <p>Address</p>
                            <mat-form-field>
                                <input matInput formControlName="address1" autocomplete="off" type="text"/>
                            </mat-form-field>
                        </div>
                        <div class="form-field">
                        <p>Postcode</p>
                            <mat-form-field>
                                <input matInput formControlName="postCode" autocomplete="off" type="text"/>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex gap-15">
                        <div class="form-field">
                            <p>Accounting Body</p>
                            <div class="d-flex gap-10">
                                <ng-select
                                class="wp-100"
                                [disableOptionCentering]="true"
                                panelClass="mat-select-position"
                                formControlName="selectedAccountingBody"
                                (change)="onAccountingBodyChange($event)"
                                >
                                    <ng-option value="0">Other/None</ng-option>
                                    <ng-option *ngFor="let item of accountingBodies" [value]="item">{{ item }}</ng-option>
                                </ng-select>
                                <mat-form-field appearance="fill">
                                    <input
                                    type="text"
                                    matInput
                                    maxlength="255"
                                    autocomplete="off"
                                    formControlName="accountingbody"
                                    />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="form-field w-220">
                        <p class="fw-bold">Date Audit</p>
                        <mat-form-field appearance="fill" class="w-270">
                            <input  matInput [min]="minInvoiceDate" [max]="maxInvoiceDate" formControlName="dateAudited" [matDatepicker]="datePicker" autocomplete="off"/>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <p class="fw-bold mb-2">Presentation of Firm (Replace Accountant/Auditor Name)</p>
                    <div class="d-flex gap-15">
                        <div class="form-field">
                            <p>Name</p>
                            <mat-form-field>
                                <input matInput formControlName="rfirmname" autocomplete="off" type="text"/>
                            </mat-form-field>
                        </div>
                        <div class="form-field">
                            <p>Office/Location</p>
                            <mat-form-field>
                                <input matInput formControlName="firmLocation" autocomplete="off" type="text"/>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
            <div class="ml-10">
                <p class="fw-bold font-size-18 mb-2" *ngIf="reports">Related Notes</p>
                <div class="notes-view">
                    <div *ngFor="let report of reports" class="d-flex align-items-center gap-10 mb-10">
                        <mat-checkbox [(ngModel)]="report.isChecked" (change)="onCheckboxClick($event, report)">
                            <p class="mb-0">{{ report.title }}</p>
                        </mat-checkbox>
                        <button mat-button disableRippl [disabled]="!report.isChecked">
                            <mat-icon [ngStyle]="{'cursor': !report.isChecked ?  'none' : 'pointer'}" (click)="GetAuditReportDetailsByType(report.type)" fontSet="material-icons-outlined">edit</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</div>

<div class="action-wrapper button-action-wrapper">
    <div class="content-body">
        <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="saveDetails('edit')"
        >
        Save
        </button>
        <button
        class="action-button secondary-button"
        mat-dialog-close
        disableRipple
        type="button"
        mat-button
        disableRipple
        >
        Cancel
        </button>
    </div>
</div>